module.exports = __webpack_public_path__ + "img/15.c04da76d.jpg";